<template>
    <v-container fluid class="rates">
        <router-view />

        <div class="rates__tabs">
            <div>
                <router-link to="/rates" active-class="active"> Все отделы </router-link>

                <router-link :to="`/rates/${my_id}`" active-class="active"> Мои отзывы </router-link>

                <router-link v-if="my_role == 'admin' || my_role == 'orp'" to="/rates/orp" active-class="active">
                    Взаимодействие между отделами
                </router-link>
            </div>
            <a id="add-new-rate" @click="new_dialog = true">Написать отзыв</a>
        </div>

        <v-dialog v-model="new_dialog" persistent max-width="855px">
            <!-- Кнопка вызова КАКОГО ИМЕННО диалогового окна -->

            <div class="send-rate">
                <img class="send-rate__close-btn" src="/images/rates/close.svg" @click="close_modal()" />
                <div class="wrapper">
                    <template v-if="before_sended">

                        <div class="send-rate__header">Напишите свое мнение или пожелание</div>
                        <div id="choose_departament">
                            <v-select
                                v-model="new_rate.to"
                                :items="filtered_rates"
                                item-text="name"
                                item-value="_id"
                                label="Выберите отдел"
                                persistent-hint
                                return-object
                                single-line
                            ></v-select>
                        </div>
                        <DepartmentCommentRate :new_rate="new_rate" @close_modal="on_close_modal" @before_send="on_before_send"></DepartmentCommentRate>
                    </template>
                    <template v-else>
                        <SecondModal :new_rate="new_rate" @edit_comment="on_before_send" @clear_modal="on_close_modal"></SecondModal>
                    </template>
                </div>
            </div>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateRate from './../components/rates/CreateRate.vue'
import NewDepartmentRate from './../components/rates/modals/NewDepartmentRate.vue'
import DepartmentCommentRate from './../components/rates/modals/DepartmentCommentRate.vue'
import SecondModal from './../components/rates/modals/SecondModal.vue'

export default {
    name: 'Rates',
    data: () => ({
        my_id: localStorage.getItem('_id'),
        my_role: localStorage.getItem('title'),
        dialog: false,
        new_dialog: false,
        before_sended : true,
        otdel: {},
        new_rate: {
            comment: '',
            progress_line: 0,
            from: localStorage.getItem('_id'),
            to: '',
            rate: 0,
            date: new Date().toISOString().substring(0, 10),
        },
    }),
    components: { CreateRate, NewDepartmentRate, DepartmentCommentRate , SecondModal},
    computed: {
        ...mapGetters(['get_rates']),

        filtered_rates() {
            return this.get_rates.filter((r) => r._id != this.new_rate.from)
        },
    },
    beforeMount() {
        this.load_rates()
    },
    methods: {
        ...mapActions(['load_rates', 'create_rate']),

        on_close_modal(value) {
            this.new_dialog = value
        },
        on_before_send(value){
            console.log(value, 'gw');     
            this.before_sended = value   
        },

        close_modal() {
            this.new_dialog = false
            this.new_rate.comment = ''
            this.new_rate.to = ''
            this.new_rate.progress_line = 0
            this.new_rate.rate = 0

            return false
        },
    },
}
</script>

<style>
.rates {
    /* min-height: 90vh; */
     min-height: 1050px;
    display: -ms-grid;
    display: grid;
    -ms-grid-rows: 1fr auto;
    grid-template-rows: 1fr auto;
    background-color: #f8f8f8;
    font-size: 18px;

    /* W3C standard сейчас только для Firefox */

    scrollbar-width: thin;
    scrollbar-color: #faaf50 #ddd;
}

/* для Chrome/Edge/Safari */
.rates *::-webkit-scrollbar {
  width: 10px;
}
.rates *::-webkit-scrollbar-track {
  background: #ddd;
}
.rates *::-webkit-scrollbar-thumb {
  background-color: #faaf50;
  border-radius: 10px;
  border: 3px solid #faaf50;
}

.rates__tabs {
    margin: 0 auto;
    width: 1214px;
    justify-content: space-between;
    display: flex;
    align-items: center;
}

.rates__tabs div a:first-child {
    margin-left: 0px;
}

.rates__tabs div a {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: #1f0303 !important;
    text-decoration: none;
    padding-top: 10px;
    margin-left: 80px;
}

.rates__tabs div a.active {
    border-top: 2px solid #ed7428;
}

.rates__tabs #add-new-rate {
    background: #ed7428;
    border-radius: 62px;
    font-weight: bold;
    font-size: 18px;
    line-height: 1;
    color: #f8f8f8 !important;
    padding: 20px 26px;
}

.send-rate {
    background-color: #fff;
    border-radius: 15px;
    position: relative;
}

.send-rate__close-btn {
    width: 20px;
    top: 30px;
    right: 30px;
    position: absolute;
    cursor: pointer;
}

.send-rate__header {
    text-align: center;
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 37px;
    color: #1f0303;
}

.send-rate__rates {
    height: 154px;
    background: #f8f8f8;
    border-radius: 30px;
    overflow-y: auto;
    padding: 28px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 40px;
}

.send-rate-form {
    margin-top: 40px;
}

.send-rate-form__text {
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    color: #1f0303;
    margin-bottom: 20px;
}

.send-rate-form textarea {
    height: 175px;
    background: #f8f8f8;
    border-radius: 30px;
    width: 100%;
    padding: 20px;
    resize: none;
}

.send-rate .wrapper {
    max-width: 600px;
    margin: 0px auto;
    padding: 60px 0;
}

.send-rate-ants {
    width: 300px;
}

.send-rate-ants__buttons {
    display: flex;
    justify-content: space-between;
}

.send-rate-ants__buttons img {
    height: 46px;
}

#choose_departament .v-select .v-input__slot {
    /* border: 1px solid #ED7428; */
    padding: 15px;
    border-radius: 15px;
    margin-top: 40px;
}
</style>